import React from "react";
import cx from "clsx";
const DEFAULT_CLASS = "react-tabs__tab-panel";
const defaultProps = {
  className: DEFAULT_CLASS,
  forceRender: false,
  selectedClassName: `${DEFAULT_CLASS}--selected`
};
const TabPanel = props => {
  const {
    children,
    className,
    forceRender,
    id,
    selected,
    selectedClassName,
    ...attributes
  } = {
    ...defaultProps,
    ...props
  };
  return React.createElement("div", Object.assign({}, attributes, {
    className: cx(className, {
      [selectedClassName]: selected
    }),
    role: "tabpanel",
    id: `panel${id}`,
    "aria-labelledby": `tab${id}`
  }), forceRender || selected ? children : null);
};
TabPanel.tabsRole = "TabPanel";
export default TabPanel;